import React, { useState } from 'react';
import { Row } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Domain from "../components_parts/Domain";
import { ConstantInterpretation } from "../components_parts";
import PredicateInterpretation from "../components_parts/PredicateInterpretation";
import FunctionInterpretation from "../components_parts/FunctionInterpretation";
import Help from "../../buttons/Help";
const structureHelp = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, "A first-order structure for language \uD835\uDCDB is defined in this section. When the language is modified, inputs for interpretations of symbols are updated accordingly."), /*#__PURE__*/React.createElement("p", {
  className: "mb-0"
}, "Syntactic requirements:"), /*#__PURE__*/React.createElement("ul", {
  className: "mb-0"
}, /*#__PURE__*/React.createElement("li", null, "Elements in all sets (the domain, interpretations of predicates and functions) are comma-separated."), /*#__PURE__*/React.createElement("li", null, "Strings of any Unicode characters except spaces, comma, and parentheses can be used as domain elements."), /*#__PURE__*/React.createElement("li", null, "An individual constant is interpreted a domain element picked from a menu."), /*#__PURE__*/React.createElement("li", null, "A unary predicate symbol is interpreted as a set of domain elements."), /*#__PURE__*/React.createElement("li", null, "An ", /*#__PURE__*/React.createElement("var", null, "n"), "-ary predicate symbol for ", /*#__PURE__*/React.createElement("var", null, "n"), "\xA0>\xA01 is interpreted as a set of ", /*#__PURE__*/React.createElement("var", null, "n"), "-tuples of domain elements. Each ", /*#__PURE__*/React.createElement("var", null, "n"), "-tuple is written as", " ", /*#__PURE__*/React.createElement("code", null, "(elem", /*#__PURE__*/React.createElement("sub", null, "1"), ", \u2026, elem", /*#__PURE__*/React.createElement("sub", null, /*#__PURE__*/React.createElement("var", null, "n")), ")"), "."), /*#__PURE__*/React.createElement("li", null, "An ", /*#__PURE__*/React.createElement("var", null, "n"), "-ary function symbol is interpreted as a set of (", /*#__PURE__*/React.createElement("var", null, "n"), "+1)-tuples of domain elements, each written as", " ", /*#__PURE__*/React.createElement("code", null, "(arg", /*#__PURE__*/React.createElement("sub", null, "1"), ", \u2026, arg", /*#__PURE__*/React.createElement("sub", null, /*#__PURE__*/React.createElement("var", null, "n")), ", value)"), ".")));

function Structure({
  structure,
  setDomain,
  lockDomain,
  teacherMode,
  setConstantValue,
  structureObject,
  lockConstantValue,
  setPredicateValueText,
  lockPredicateValue,
  toggleTable,
  toggleDatabase,
  domain,
  setPredicateValueTable,
  setFunctionValueText,
  lockFunctionValue,
  setFunctionValueTable
}) {
  let constants = Object.keys(structure.constants);
  let predicates = Object.keys(structure.predicates);
  let functions = Object.keys(structure.functions);
  const [showHelp, setShowHelp] = useState(false);
  return /*#__PURE__*/React.createElement(Card, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Card.Header, {
    as: "h5",
    className: "d-flex justify-content-between"
  }, /*#__PURE__*/React.createElement("span", null, "Structure \uD835\uDCDC = (", /*#__PURE__*/React.createElement("var", null, "D"), ", ", /*#__PURE__*/React.createElement("var", null, "i"), ")"), /*#__PURE__*/React.createElement(Help, {
    subject: "language",
    children: structureHelp,
    onToggle: setShowHelp,
    show: showHelp
  })), /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Domain, {
    structure: structure,
    setDomain: setDomain,
    lockDomain: lockDomain,
    teacherMode: teacherMode,
    lengthOfCol: 12
  })), constants.length === 0 ? null : /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(ConstantInterpretation, {
    structure: structure,
    teacherMode: teacherMode,
    constants: constants,
    lockConstantValue: lockConstantValue,
    setConstantValue: setConstantValue,
    structureObject: structureObject,
    lengthOfCol: 12
  })), predicates.length === 0 ? null : /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(PredicateInterpretation, {
    structureObject: structureObject,
    structure: structure,
    toggleDatabase: toggleDatabase,
    teacherMode: teacherMode,
    domain: domain,
    lockPredicateValue: lockPredicateValue,
    predicates: predicates,
    setPredicateValueTable: setPredicateValueTable,
    setPredicateValueText: setPredicateValueText,
    toggleTable: toggleTable,
    lengthOfCol: 12
  })), functions.length === 0 ? null : /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(FunctionInterpretation, {
    toggleTable: toggleTable,
    toggleDatabase: toggleDatabase,
    domain: domain,
    teacherMode: teacherMode,
    structure: structure,
    structureObject: structureObject,
    functions: functions,
    lockFunctionValue: lockFunctionValue,
    setFunctionValueTable: setFunctionValueTable,
    setFunctionValueText: setFunctionValueText,
    lengthOfCol: 12
  }))));
}

export default Structure;